<template>
  <div>
    <div class="wrapper d-flex flex-column">
      <img src="@/assets/dn2me.svg" class="image" />

      <div class="cell">
        <router-view></router-view>
      </div>

      <img class="sideImage" src="@/assets/sidelogo.png" alt />

      <!-- <div style="position:absolute; bottom: 15px;" class="footer"> -->
      <Footer class="mt-12 footer" />
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Footer
  }
  // data(){
  //     return{
  //     }
  // }
};
</script>

<style lang="scss" scoped>
.wrapper {
  min-height: 100vh;
  width: 100%;
  background-color: rgb(244, 244, 244);

  .footer {
    align-self: center;
  }

  .sideImage {
    position: fixed;
    right: -50px;
    top: 20%;
  }

  .image {
    width: auto;
    height: 100px;
  }

  .cell {
    min-height: 600px;
    margin-top: 50px;
    align-self: center;
    background-color: white;
    width: 800px;
    z-index: 2;
    -webkit-box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.15);
  }

  @media only screen and (max-width: 600px) {
    .cell {
      width: 100vw;
      min-height: 100vh;
      z-index: 10;
      margin: 0;
    }

    .image {
      display: none;
    }

    .sideImage {
      display: none;
    }

    .footer {
      display: none !important;
    }
  }
}
</style>